import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WordList, getStoredWordLists, saveStoredWordLists } from "@src/pages/wordzapp/wordzappData";

interface WordzappState {
  selectedListId: string | null;
  selectedGroupId: string | null;
  lists: WordList[];
}

const initialLists = getStoredWordLists();

const initialState: WordzappState = {
  selectedListId: null,
  selectedGroupId: null,
  lists: initialLists,
};

const wordzappSlice = createSlice({
  name: "wordzapp",
  initialState,
  reducers: {
    setSelectedListId: (state, action: PayloadAction<string | null>) => {
      state.selectedListId = action.payload;
      if (action.payload === null) {
        state.selectedGroupId = null;
      }
    },
    setSelectedGroupId: (state, action: PayloadAction<string | null>) => {
      state.selectedGroupId = action.payload;
    },
    setWordLists: (state, action: PayloadAction<WordList[]>) => {
      state.lists = action.payload;
      saveStoredWordLists(action.payload);
    },
    resetWordzappNavigation: (state) => {
      state.selectedListId = null;
      state.selectedGroupId = null;
    },
  },
});

export const {
  setSelectedListId,
  setSelectedGroupId,
  setWordLists,
  resetWordzappNavigation,
} = wordzappSlice.actions;

export default wordzappSlice.reducer;
